const articles = [
  {
    category: "基礎知識",
    title: "なぜパンプスは脱げるのか？原因と対策を徹底解説",
    readTime: "5分",
    image: "https://readdy.ai/api/search-image?query=elegant%20nude%20beige%20leather%20pumps%20on%20white%20marble%20surface%20with%20soft%20natural%20light%2C%20minimalist%20product%20photography%2C%20warm%20cream%20background%2C%20fashion%20magazine%20style%2C%20top%20down%20view%2C%20clean%20and%20sophisticated&width=600&height=400&seq=article1&orientation=landscape",
  },
  {
    category: "サイズ選び",
    title: "細幅の人がサイズを上げると危険？正しいサイズの選び方",
    readTime: "4分",
    image: "https://readdy.ai/api/search-image?query=close%20up%20of%20womans%20feet%20in%20elegant%20beige%20pumps%20with%20measuring%20tape%20nearby%2C%20shoe%20fitting%20process%2C%20warm%20natural%20light%2C%20cream%20and%20neutral%20tones%2C%20professional%20yet%20approachable%2C%20lifestyle%20photography&width=600&height=400&seq=article2&orientation=landscape",
  },
  {
    category: "お悩み別",
    title: "楽な靴ばかり選んでしまう理由と、おしゃれとの両立方法",
    readTime: "6分",
    image: "https://readdy.ai/api/search-image?query=stylish%20Japanese%20woman%20sitting%20in%20cafe%20wearing%20elegant%20pumps%20looking%20comfortable%20and%20happy%2C%20warm%20indoor%20natural%20light%2C%20cream%20and%20beige%20outfit%2C%20lifestyle%20portrait%20photography%2C%20fashion%20editorial%20feeling&width=600&height=400&seq=article3&orientation=landscape",
  },
  {
    category: "就活",
    title: "就活パンプス問題。長時間履いても疲れにくい選び方",
    readTime: "5分",
    image: "https://readdy.ai/api/search-image?query=elegant%20black%20court%20pumps%20on%20light%20wooden%20floor%20with%20formal%20bag%2C%20professional%20yet%20stylish%2C%20warm%20natural%20light%2C%20minimalist%20background%2C%20fashion%20photography%2C%20clean%20and%20crisp&width=600&height=400&seq=article4&orientation=landscape",
  },
  {
    category: "ヒール",
    title: "ヒール疲れを減らすには？インソールと靴選びの関係",
    readTime: "5分",
    image: "https://readdy.ai/api/search-image?query=woman%20walking%20gracefully%20in%20elegant%20heeled%20pumps%20on%20clean%20light%20urban%20pavement%2C%20candid%20lifestyle%20photography%2C%20warm%20afternoon%20light%2C%20fashion%20editorial%20style%2C%20natural%20and%20comfortable%20movement%2C%20tasteful&width=600&height=400&seq=article5&orientation=landscape",
  },
];

export default function ContentSection() {
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <p
              className="text-[#B8895A] text-xs tracking-widest mb-4 uppercase"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              Knowledge
            </p>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#1C1917] leading-snug"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              綺麗に履くための、
              <br />
              足と靴の読みもの。
            </h2>
          </div>
          <a
            href="#blog"
            className="flex items-center gap-2 text-[#B8895A] text-sm font-medium whitespace-nowrap hover:text-[#1C1917] transition-colors cursor-pointer self-end"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            すべての記事を見る
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* Articles grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {/* Featured large article */}
          <a
            href="#"
            className="lg:col-span-2 group block bg-[#FAFAF8] rounded-2xl overflow-hidden border border-[#F0EBE3] hover:border-[#B8895A]/30 transition-all cursor-pointer"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 h-full">
              <div className="h-48 md:h-auto overflow-hidden">
                <img
                  src={articles[0].image}
                  alt={articles[0].title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 flex flex-col justify-between">
                <div>
                  <span
                    className="bg-[#F5F0EA] text-[#B8895A] text-xs px-3 py-1 rounded-full whitespace-nowrap"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {articles[0].category}
                  </span>
                  <h3
                    className="text-[#1C1917] text-base font-bold leading-snug mt-4 mb-3 group-hover:text-[#B8895A] transition-colors"
                    style={{ fontFamily: "'Noto Serif JP', serif" }}
                  >
                    {articles[0].title}
                  </h3>
                </div>
                <div className="flex items-center gap-2 text-[#78716C] text-xs" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  <i className="ri-time-line text-xs" />
                  <span>読了目安 {articles[0].readTime}</span>
                </div>
              </div>
            </div>
          </a>

          {/* Regular articles */}
          {articles.slice(1, 4).map((article, i) => (
            <a
              key={i}
              href="#"
              className="group block bg-[#FAFAF8] rounded-2xl overflow-hidden border border-[#F0EBE3] hover:border-[#B8895A]/30 transition-all cursor-pointer"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span
                  className="bg-[#F5F0EA] text-[#B8895A] text-xs px-2.5 py-1 rounded-full whitespace-nowrap"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {article.category}
                </span>
                <h3
                  className="text-[#1C1917] text-sm font-bold leading-snug mt-3 mb-3 group-hover:text-[#B8895A] transition-colors line-clamp-2"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {article.title}
                </h3>
                <div className="flex items-center gap-1 text-[#78716C] text-xs" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  <i className="ri-time-line text-xs" />
                  <span>読了目安 {article.readTime}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}